// extracted by mini-css-extract-plugin
module.exports = {"blinking":"_3dPG2","blink":"_3hLsP"};